import script from "./PrivacyLevelIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyLevelIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./PrivacyLevelIndicator.vue?vue&type=style&index=0&id=88f7df30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88f7df30"]])

export default __exports__